module.exports = __webpack_public_path__ + "static/media/bg-music-guitar.e4720109.jpg";